import React, { useState, useEffect } from 'react';
import { Clock, AlertTriangle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const DeadlineCountdown = ({ deadline, status, className = "" }) => {
  const [timeLeft, setTimeLeft] = useState("");
  const [isOverdue, setIsOverdue] = useState(false);

  useEffect(() => {
    if (!deadline) return;

    const calculateTimeLeft = () => {
      const now = new Date();
      const deadlineDate = new Date(deadline);
      const diff = deadlineDate - now;

      if (diff <= 0) {
        setIsOverdue(true);
        const overdueDiff = Math.abs(diff);
        const days = Math.floor(overdueDiff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((overdueDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        
        if (days > 0) {
          setTimeLeft(`Overdue by ${days}d ${hours}h`);
        } else {
          setTimeLeft(`Overdue by ${hours}h`);
        }
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      if (days > 0) {
        setTimeLeft(`${days}d ${hours}h left`);
      } else if (hours > 0) {
        setTimeLeft(`${hours}h ${minutes}m left`);
      } else {
        setTimeLeft(`${minutes}m left`);
      }
      
      setIsOverdue(false);
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [deadline]);

  if (!deadline) return null;

  const isCompleted = status === 'completed';
  const showOverdue = isOverdue || status === 'overdue';

  return (
    <Badge 
      className={`
        ${className}
        ${showOverdue && !isCompleted ? 'bg-red-600 text-white' : ''}
        ${!showOverdue && !isCompleted ? 'bg-orange-100 text-orange-800' : ''}
        ${isCompleted ? 'bg-gray-200 text-gray-600' : ''}
        flex items-center gap-1
      `}
    >
      {showOverdue && !isCompleted ? (
        <AlertTriangle className="w-3 h-3" />
      ) : (
        <Clock className="w-3 h-3" />
      )}
      {timeLeft}
    </Badge>
  );
};

export default DeadlineCountdown;
